import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Res } from '../models';
import { ApiBasicService } from './api-basic.service';

@Injectable({
  providedIn: 'root'
})
export class ApiCategoriesService {

  constructor(
    private apiBasic: ApiBasicService
  ) { }


  /**
   * 
   * @param params any
   * @returns Observable<Res>
   */
  getReferences(params: any, moduleName: string): Observable<Res> {

    return this.apiBasic.getReferences(params, moduleName);
  }

  /**
   * 
   * @param params any
   * @returns Observable<Res>
   */
  getList(params: any): Observable<Res> {

    return this.apiBasic.getList(params, 'category');
  }

  /**
   * 
   * @param id string
   * @returns Observable<Res>
   */
  edit(type:string, id: string): Observable<Res> {

    return this.apiBasic.edit(type, id);
  }

  /**
  * 
  * @param params any
  * @returns Observable<Res>
  */
  create(type:string, params: any): Observable<Res> {

    return this.apiBasic.create(type, params);
  }

  /**
  * 
  * @param params any
  * @returns Observable<Res>
  */
  createMyCategory(params: any): Observable<Res> {

    return this.apiBasic.create('categories_to_roles', params);
  }

  /**
  * 
  * @param params any
  * @returns Observable<Res>
  */
  update(methodName: string, params: any): Observable<Res> {

    return this.apiBasic.update(methodName, params);
  }

  /**
  * 
  */
  delete(type:string, params: any): Observable<Res> {

    return this.apiBasic.delete(type, params);
  }
  /**
  * 
  */
  deleteMyCategory(params: any): Observable<Res> {

    return this.apiBasic.delete('categories_to_roles', params);
  }

}
